import client from './client'
import type { LoginRequest, LoginResponse, RefreshResponse } from '@/types/auth'
import { isMockMode, enableMockMode, mockLogin } from './mock'
import axios from 'axios'

export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  if (isMockMode()) return mockLogin(credentials.email, credentials.password)
  try {
    const { data } = await client.post<LoginResponse>('/api/v1/auth/login', credentials)
    return data
  } catch (err) {
    if (axios.isAxiosError(err) && !err.response) {
      enableMockMode()
      return mockLogin(credentials.email, credentials.password)
    }
    throw err
  }
}

export async function refreshToken(refresh_token: string): Promise<RefreshResponse> {
  if (isMockMode()) {
    return { access_token: `mock-at-${Date.now()}`, refresh_token: `mock-rt-${Date.now()}`, expires_in: 900 }
  }
  const { data } = await client.post<RefreshResponse>('/api/v1/auth/refresh', { refresh_token })
  return data
}

export async function logout(refresh_token: string): Promise<void> {
  if (isMockMode()) return
  await client.post('/api/v1/auth/logout', { refresh_token })
}
